import React from 'react'
import Header from "../components/Layout/Header"
import Sidebar from '../components/Layout/Sidebar';
import SubscriptionPricing from '../components/Subscription/SubscriptionPricing';

const SubscriptionPage = () => {
  
  return (
    <div className="subscription-page-container">
        <Header />
        <Sidebar />
        <main className="subscription-page-main">
          <section className="subscription-page-card">
            <SubscriptionPricing />
          </section>
        </main>
    </div>
  )
}

export default SubscriptionPage;